// @flow
import { DemandasActionTypes } from './constants';

type DemandasAction = { type: string, payload: {} | string };

// common success
export const demandasApiResponseSuccess = (actionType: string, data: any): DemandasAction => ({
    type: DemandasActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const demandasApiResponseError = (actionType: string, error: string): DemandasAction => ({
    type: DemandasActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getDemanda = (id: string): DemandasAction => ({
    type: DemandasActionTypes.GET_DEMANDA,
    payload: { id },
});

export const addDemanda = (demanda:any):DemandasAction=>({
    type:DemandasActionTypes.ADD_DEMANDA,
    payload:demanda
})
export const updateDemanda = (demanda:any):DemandasAction=>({
    type:DemandasActionTypes.UPDATE_DEMANDA,
    payload:demanda
})
export const deleteDemanda = (id:string):DemandasAction=>({
    type:DemandasActionTypes.DELETE_DEMANDA,
    payload:{id}
})

export const listDemandas = (params:any): DemandasAction => ({
    type: DemandasActionTypes.LIST_DEMANDAS,
    payload: params,
});

export const resetDemandas = (): DemandasAction => ({
    type: DemandasActionTypes.RESET,
    payload: {},
});

